module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-left-73be4699.svg";